import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Moment from 'react-moment'
import 'moment/locale/ru';
import InlineRating from '../Rating/Inline.jsx';
import UserBox from '../Helpers/User/UserBox';
import { observer, inject } from 'mobx-react';
import { observable, makeObservable, reaction, toJS } from 'mobx';
import {custom} from "../../utils/linker";
import CommentAttachments from "./CommentAttachments";
import ReplyForm from "./ReplyForm";
import { Element } from 'react-scroll';
import Form from "./Form";
import Tooltip from "../Helpers/Tooltip";
import historyVars from "../../utils/historyVars";
import Interactive from "./Interactive";
import HTML from "../Helpers/HTML";
import UserTriangle from "../Helpers/User/UserTriangle";
import qs from "qs";


class CommentItem extends Component {
  edit=false;
  constructor(props) {
    super(props);
    makeObservable(this,{
      edit:observable,
    });
    this._editReaction=reaction(()=>{
      return this.edit;
    },()=>{
      if(this.edit) {
        this._oldState=toJS(this.props.linker.value);
      }
    });
  }
  componentWillUnmount() {

  }
  getLevel() {
    let level=this.props.linker.value.level;
    if(level) {
      if (level > 5) {
        level = 5;
      }
    }
    return level;
  }
  getMarginLeft() {
    if(typeof this.props.force_margin !== 'undefined') {
      return this.props.force_margin;
    }
    if(this.props.commentsStore.small_mode === true) {
      return 0;
    }
    let level=this.props.linker.value.level;
    if(level) {
      if(level>5) {
        level=5;
      }
      if(this.props.grid_mode == 's') {
        return 7 * level;
      } else {
        return 20 * level;
      }
    }
  }
  canEdit() {
    if(!this.props.meStore.me.data) {
      return false;
    }

    if(this.props.meStore.me.data.id != this.props.linker.value.created_by) {
      return false;
    }
    let time=toJS(this.props.linker.value.time);
    if(time) {
      time=parseInt(time['$date']['$numberLong']);

      const seconds=parseInt((this.props.commentsStore.list.data.now - time)/1000);

      if(seconds < 15*60) {
        return true;
      }
    }
    return false;
  }
  isTopicStarter() {
    if(!this.props.linker.value.user) {
      return false;
    }
    return this.props.linker.value.user.id == this.props.commentsStore.topic_starter;
  }
  permalink() {
    if(this.props.onPermaLink) {
      this.props.onPermaLink(this.props.linker.value);
    } else {
      historyVars.appendVars({[this.props.commentsStore.comment_url_var]: this.props.linker.value._id});
    }
  }
  generatePermalink(child)
  {
    let url;
    if(this.props.getPermaLink) {
      url=this.props.getPermaLink();
    } else {
      const search=this.props.router.location.search;
      const parsed=qs.parse(search, {ignoreQueryPrefix: true});
      parsed[this.props.commentsStore.comment_url_var]=this.props.linker.value._id;
      url=`${this.props.router.location.pathname}?${qs.stringify(parsed)}`;
    }
    const className="clear w3 tdni";

    if(!url) {
      return (
        <span className={className}>{child}</span>
      )
    }
    if(this.props.getPermaLink) {
      if(this.props.commentsStore.standalone) {
        return (
          <a className={className} href={url}>{child}</a>
        );
      } else {
        return (
          <Link className={className} to={this.props.getPermaLink()}>{child}</Link>
        );
      }
    } else {
      return (
        <Link className={className} to={url}>{child}</Link>
      )
    }
  }
  renderDots() {
    if(this.props.commentsStore.hidden_counters[this.props.linker.value._id]) {
      return null;
    }
    if(typeof this.props.force_margin !== 'undefined') {
      return null;
    }
    if(this.props.commentsStore.small_mode === true) {
      return null;
    }
    const level=this.getLevel();
    let items=[];
    for(let i=0; i<=level;i++) {
      if(i === level) {
        items.push(
          <div title={this.props.translateStore.t.lk.collapse_tree} onClick={()=>{
            this.props.commentsStore.closeTree(this.props.linker.value._id);
          } }  key={i} className="pointer op-hover commentDot pa rad200 solid2 bo-pc1" style={{top:5,left: -15 + 20*i, width:10, height: 10, }}></div>
        );
      } else {
        items.push(
          <div key={i} className="op-hover commentDot pa rad200 solid2 bo-pc1" style={{top:8,left: -10 + 19*i }}></div>
        );
      }
    }
    return items;
  }
  render() {
    if(this.props.commentsStore.hidden_comments[this.props.linker.value._id] && !this.props.commentsStore.hidden_counters[this.props.linker.value._id]) {
      /*if(this.props.commentsStore.hidden_counters[this.props.linker.value._id]) {
        return (
          <div onClick={()=>{
            this.props.commentsStore.openTree(this.props.linker.value._id);
          }} className="mbottom15" style={{marginLeft:this.getMarginLeft() }}>
            <span className="pc1 fs14  dashed1-bottom bo-pc1 pointer">{this.props.translateStore.t.lk.expand_tree} ({this.props.commentsStore.hidden_counters[this.props.linker.value._id]})</span>
          </div>
        )
      }*/
      return null;
    }
    return (
      <div className="pr hover">
        {this.edit?(
          <div style={{marginLeft:this.getMarginLeft() }}>
            <Form onCommentPost={()=>{ if(this.props.onCommentPost) { this.props.onCommentPost(); } }} onCancelEdit={(success)=>{ if(!success){ this.props.linker.value=this._oldState; } this.edit=false; }} edit_linker={this.props.linker} />
          </div>
        ):(
          <>
            <div name={`comment-${this.props.linker.value._id}`} className={`${this.props.linker.value.new_comment && !this.props.commentsStore.readed[this.props.linker.value._id]?'boxShadow bo-b1':'bo-w2'} solid1 hov bg-w1 rad4 commentItem pr s-mbottom5 m-mbottom10 wordBreak`} style={{marginLeft:this.getMarginLeft() }}>
              <div className="up12 solid1-bottom bo-w2 splice">
                {this.props.commentsStore.hidden_counters[this.props.linker.value._id]?null:(
                  <div className="cell s-shrink">
                    {this.props.linker.value.user?(
                      <UserBox
                        avatar={this.props.linker.value.user.avatar}
                        nick={this.props.linker.value.user.nick}
                        className="rad4-tl"
                        disable_rad={true}
                        size={this.props.commentsStore.small_mode?30:40}
                      />
                    ):null}
                  </div>
                )}
                <div className="cell s-middle s-auto s-middle">
                  <div className={`s-fs12 m-fs14 pleft10 ${this.props.commentsStore.hidden_counters[this.props.linker.value._id]?'vpadd5':''}`}>
                    {this.props.linker.value.user?(
                      <>
                        {this.props.commentsStore.standalone?(
                          <a href={`/shelf/${this.props.linker.value.user.nick}`}>{this.props.linker.value.user.nick}</a>
                        ):(
                          <Link to={`/shelf/${this.props.linker.value.user.nick}`}>{this.props.linker.value.user.nick}</Link>
                        )}
                        <UserTriangle nick={this.props.linker.value.user.nick} standalone={this.props.commentsStore.standalone} />
                      </>
                      ):null}
                    {this.isTopicStarter()?(
                      <Tooltip text={this.props.translateStore.t.lk.element_author}>
                        <i className="mdi mdi-crown fs16 lh10 const5"></i>
                      </Tooltip>
                    ):null}
                    {this.props.commentsStore.hidden_counters[this.props.linker.value._id]?null:(
                      <div className={`${this.props.commentsStore.small_mode?"fs11":"fs13"} w3`}>
                        {this.generatePermalink(<Moment locale={this.props.translateStore.t.locale} format={this.props.commentsStore.small_mode?'DD.MM.YYYY mm:ss':'LLL'}>{this.props.linker.value.time_str}</Moment>)}
                      </div>
                    )}
                  </div>
                </div>
                {this.props.commentsStore.hidden_counters[this.props.linker.value._id]?null:(
                  <div className="cell s-shrink s-middle">
                    <InlineRating linker={this.props.linker} module_id={this.props.linker.value._id} module_code={"MongoComments"} />
                  </div>
                )}
              </div>
              <div className="padd10 ofh pr" style={{ ...this.props.commentsStore.hidden_counters[this.props.linker.value._id]?{maxHeight:100}:{} }}>
                <Interactive>
                  <div className="commentBody fs14 lh16" dangerouslySetInnerHTML={{__html:this.props.linker.value.text}} />
                </Interactive>
                <CommentAttachments attachments={this.props.linker.value.attachments} />
                {this.props.commentsStore.hidden_counters[this.props.linker.value._id]?(
                  <div className="pa pa-bl w100 commentsHideGradient rad4-bl rad4-br"></div>
                ):null}
              </div>
              {this.props.commentsStore.hidden_counters[this.props.linker.value._id]?null:(
                <>
                  {!this.props.commentsStore.small_mode && this.props.linker.value.user && this.props.linker.value.user.signature?(
                    <div className="fs12 pleft10 pright10 ptop5 pbottom5 dotted1-top bo-w2">
                      <div className="ofh commentSignature">
                        <HTML>{this.props.linker.value.user.signature}</HTML>
                      </div>
                    </div>
                  ):null}
                </>
              )}
              {this.props.commentsStore.hidden_counters[this.props.linker.value._id]?null:(
                <div className="up12 splice s-fs12 m-fs14">
                  {!this.props.disable_edit?(
                    <div className="cell s-auto s-pleft5 m-pleft10 s-middle op-hov">

                      {this.props.commentsStore.list.data.permissions.can_moderate?(
                        <span onClick={()=>{ if(window.confirm(`Удалить комментарий от ${this.props.linker.value.user?this.props.linker.value.user.nick:''}? Все ответы будут также удалены.`)){ this.props.commentsStore.deleteComment(this.props.linker.value._id); } }} className="const2-op50 const2-hover pointer ">Удалить</span>
                      ):null}

                      {(this.props.commentsStore.list.data.permissions.can_moderate || this.canEdit()) && !this.props.linker.value.old?(
                        <span onClick={()=>{ this.edit=true; }} className="pc1-op50 pc1-hover pointer mleft10">{this.props.translateStore.t.lk.edit_comment}</span>
                      ):null}
                    </div>
                  ):null}
                  {!this.props.disable_reply?(
                    <div className="cell s-shrink s-pright5 s-pbottom5 m-pright10 m-pbottom10">
                      <span className="mdi mdi-reply pointer w4" onClick={()=>{ this.props.commentsStore.replyTo(this.props.linker.value); }}> {this.props.translateStore.t.lk.reply}</span>
                    </div>
                  ):null}
                </div>
              )}
            </div>
            {this.props.commentsStore.hidden_counters[this.props.linker.value._id]?(
                <div onClick={()=>{
                    this.props.commentsStore.openTree(this.props.linker.value._id);
                  }} className="mbottom15 pleft20" style={{marginLeft:this.getMarginLeft() }}>
                  <span className="pc1 fs14  dashed1-bottom bo-pc1 pointer">{this.props.translateStore.t.lk.expand_tree} ({this.props.commentsStore.hidden_counters[this.props.linker.value._id]-1})</span>
                </div>
            ):null}
            <ReplyForm onCommentPost={()=>{ console.log("POSTED"); if(this.props.onCommentPost) { this.props.onCommentPost(); } }} id={this.props.linker.value._id} marginLeft={this.getMarginLeft()} />
          </>
        )}
        {this.renderDots()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    translate:state.translate,
    grid_mode:state.grid_mode,
  }
}


export default inject("translateStore","commentsStore","meStore","router")(observer(CommentItem));